/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Pharmacy Counselor API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";
import {
  PharmacyCounselorCounselingRequestBilling,
  PharmacyCounselorCounselingRequestBillingFromJSON,
  PharmacyCounselorCounselingRequestBillingFromJSONTyped,
  PharmacyCounselorCounselingRequestBillingToJSON,
  PharmacyCounselorDelivery,
  PharmacyCounselorDeliveryFromJSON,
  PharmacyCounselorDeliveryFromJSONTyped,
  PharmacyCounselorDeliveryToJSON,
  PharmacyCounselorMynaHomeWeb,
  PharmacyCounselorMynaHomeWebFromJSON,
  PharmacyCounselorMynaHomeWebFromJSONTyped,
  PharmacyCounselorMynaHomeWebToJSON,
  PharmacyCounselorPersonalHealthRecordRegistrable,
  PharmacyCounselorPersonalHealthRecordRegistrableFromJSON,
  PharmacyCounselorPersonalHealthRecordRegistrableFromJSONTyped,
  PharmacyCounselorPersonalHealthRecordRegistrableToJSON,
  PharmacyCounselorPostCounselingRequestPatient,
  PharmacyCounselorPostCounselingRequestPatientFromJSON,
  PharmacyCounselorPostCounselingRequestPatientFromJSONTyped,
  PharmacyCounselorPostCounselingRequestPatientToJSON,
  PharmacyCounselorPrescriptionRegistrable,
  PharmacyCounselorPrescriptionRegistrableFromJSON,
  PharmacyCounselorPrescriptionRegistrableFromJSONTyped,
  PharmacyCounselorPrescriptionRegistrableToJSON,
  PharmacyCounselorServiceNeeds,
  PharmacyCounselorServiceNeedsFromJSON,
  PharmacyCounselorServiceNeedsFromJSONTyped,
  PharmacyCounselorServiceNeedsToJSON,
} from "./";

export const PostCounselingRequestBodyTypename = "PostCounselingRequestBody" as const;

/**
 *
 * @export
 * @interface PostCounselingRequestBody
 */
export interface PostCounselingRequestBody {
  /**
   * AI Assistant issued accept code (only for ai_assisted_reception; pharmacy issues a new code if omitted)
   * @type {number}
   * @memberof PostCounselingRequestBody
   */
  acceptCode?: number;
  /**
   * AI Assistant counseling ID
   * @type {string}
   * @memberof PostCounselingRequestBody
   */
  aiAssistantCounselingId?: string;
  /**
   * AI Assistant reception view data
   * @type {object}
   * @memberof PostCounselingRequestBody
   */
  aiAssistantReceptionView?: object;
  /**
   *
   * @type {PharmacyCounselorCounselingRequestBilling}
   * @memberof PostCounselingRequestBody
   */
  billing?: PharmacyCounselorCounselingRequestBilling;
  /**
   *
   * @type {number}
   * @memberof PostCounselingRequestBody
   */
  childWeight?: number;
  /**
   *
   * @type {number}
   * @memberof PostCounselingRequestBody
   */
  clinicCounselingId?: number;
  /**
   *
   * @type {number}
   * @memberof PostCounselingRequestBody
   */
  clinicId?: number;
  /**
   *
   * @type {string}
   * @memberof PostCounselingRequestBody
   */
  correlationId?: string;
  /**
   * required if type is online_counseling or payment_method is online
   * @type {string}
   * @memberof PostCounselingRequestBody
   */
  creditCardId?: string;
  /**
   * The patient's current symptoms
   * @type {string}
   * @memberof PostCounselingRequestBody
   */
  currentSymptoms?: string;
  /**
   *
   * @type {PharmacyCounselorDelivery}
   * @memberof PostCounselingRequestBody
   */
  delivery?: PharmacyCounselorDelivery;
  /**
   * required if direct_visit and app_name is 'pharmacy'
   * @type {string}
   * @memberof PostCounselingRequestBody
   */
  dispensingType?: PostCounselingRequestBodyDispensingTypeEnum;
  /**
   *
   * @type {number}
   * @memberof PostCounselingRequestBody
   */
  familyAccountId?: number;
  /**
   * required if type online_counseling or dispensing
   * @type {string}
   * @memberof PostCounselingRequestBody
   */
  hasMedicineNotebook?: PostCounselingRequestBodyHasMedicineNotebookEnum;
  /**
   *
   * @type {string}
   * @memberof PostCounselingRequestBody
   */
  insuranceCardType?: PostCounselingRequestBodyInsuranceCardTypeEnum;
  /**
   *
   * @type {boolean}
   * @memberof PostCounselingRequestBody
   */
  isIntegrated?: boolean;
  /**
   *
   * @type {string}
   * @memberof PostCounselingRequestBody
   */
  message?: string;
  /**
   * E-Mail text
   * @type {string}
   * @memberof PostCounselingRequestBody
   */
  messageToPatient?: string;
  /**
   *
   * @type {PharmacyCounselorMynaHomeWeb}
   * @memberof PostCounselingRequestBody
   */
  mynaHomeWeb?: PharmacyCounselorMynaHomeWeb;
  /**
   *
   * @type {object}
   * @memberof PostCounselingRequestBody
   */
  optionalInformation?: object;
  /**
   *
   * @type {PharmacyCounselorPostCounselingRequestPatient}
   * @memberof PostCounselingRequestBody
   */
  patient?: PharmacyCounselorPostCounselingRequestPatient;
  /**
   *
   * @type {PharmacyCounselorPersonalHealthRecordRegistrable}
   * @memberof PostCounselingRequestBody
   */
  personalHealthRecord?: PharmacyCounselorPersonalHealthRecordRegistrable;
  /**
   *
   * @type {number}
   * @memberof PostCounselingRequestBody
   */
  pharmacyId: number;
  /**
   *
   * @type {Array<string>}
   * @memberof PostCounselingRequestBody
   */
  preferredTimes?: Array<string>;
  /**
   *
   * @type {PharmacyCounselorPrescriptionRegistrable}
   * @memberof PostCounselingRequestBody
   */
  prescription?: PharmacyCounselorPrescriptionRegistrable;
  /**
   *
   * @type {Array<string>}
   * @memberof PostCounselingRequestBody
   */
  prescriptions?: Array<string>;
  /**
   *
   * @type {string}
   * @memberof PostCounselingRequestBody
   */
  requestType?: PostCounselingRequestBodyRequestTypeEnum;
  /**
   * 残置種別（Aアシ予約時のみ指定可。null = 残置でない）
   * @type {string}
   * @memberof PostCounselingRequestBody
   */
  resumeStatus?: PostCounselingRequestBodyResumeStatusEnum;
  /**
   *
   * @type {PharmacyCounselorServiceNeeds}
   * @memberof PostCounselingRequestBody
   */
  serviceNeeds?: PharmacyCounselorServiceNeeds;
  /**
   *
   * @type {string}
   * @memberof PostCounselingRequestBody
   */
  type: PostCounselingRequestBodyTypeEnum;
  /**
   *
   * @type {string}
   * @memberof PostCounselingRequestBody
   */
  waitingLabel?: PostCounselingRequestBodyWaitingLabelEnum;
  /**
   * required if type online_counseling or dispensing
   * @type {string}
   * @memberof PostCounselingRequestBody
   */
  wantsGeneric?: PostCounselingRequestBodyWantsGenericEnum;
  /**
   * Resource type name
   * @type {string}
   * @memberof PostCounselingRequestBody
   */
  readonly __typename?: string;
}

/**
 * @export
 * @enum {string}
 */
export enum PostCounselingRequestBodyDispensingTypeEnum {
  Normal = "normal",
  Quick = "quick",
} /**
 * @export
 * @enum {string}
 */
export enum PostCounselingRequestBodyHasMedicineNotebookEnum {
  None = "none",
  Paper = "paper",
  Digital = "digital",
  Yqb = "yqb",
} /**
 * @export
 * @enum {string}
 */
export enum PostCounselingRequestBodyInsuranceCardTypeEnum {
  Health = "health",
  Myna = "myna",
} /**
 * @export
 * @enum {string}
 */
export enum PostCounselingRequestBodyRequestTypeEnum {
  Web = "web",
  Line = "line",
} /**
 * @export
 * @enum {string}
 */
export enum PostCounselingRequestBodyResumeStatusEnum {
  CameBackOnSameDay = "came_back_on_same_day",
  CameBackOnDifferentDay = "came_back_on_different_day",
  PrescriptionPreSubmitted = "prescription_pre_submitted",
  PickUpMissingMedicine = "pick_up_missing_medicine",
} /**
 * @export
 * @enum {string}
 */
export enum PostCounselingRequestBodyTypeEnum {
  OnlineCounseling = "online_counseling",
  Dispensing = "dispensing",
  FollowUpOnly = "follow_up_only",
  DeliveryOnly = "delivery_only",
  DirectVisit = "direct_visit",
  AiAssistedReception = "ai_assisted_reception",
  OnlineOtcGuidance = "online_otc_guidance",
} /**
 * @export
 * @enum {string}
 */
export enum PostCounselingRequestBodyWaitingLabelEnum {
  GoOut = "go_out",
  AfterTomorrow = "after_tomorrow",
  Hurry = "hurry",
  Ambiguous = "ambiguous",
  UrgencyLow = "urgency_low",
  UrgencyMiddle = "urgency_middle",
  UrgencyHigh = "urgency_high",
  HasContact = "has_contact",
} /**
 * @export
 * @enum {string}
 */
export enum PostCounselingRequestBodyWantsGenericEnum {
  None = "none",
  Want = "want",
  Consultation = "consultation",
}

export function PostCounselingRequestBodyFromJSON(json: any): PostCounselingRequestBody {
  return PostCounselingRequestBodyFromJSONTyped(json, false);
}

export function PostCounselingRequestBodyFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PostCounselingRequestBody {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PostCounselingRequestBodyTypename,

    acceptCode: !exists(json, "accept_code") ? undefined : json["accept_code"],
    aiAssistantCounselingId: !exists(json, "ai_assistant_counseling_id")
      ? undefined
      : json["ai_assistant_counseling_id"],
    aiAssistantReceptionView: !exists(json, "ai_assistant_reception_view")
      ? undefined
      : json["ai_assistant_reception_view"],
    billing: !exists(json, "billing") ? undefined : PharmacyCounselorCounselingRequestBillingFromJSON(json["billing"]),
    childWeight: !exists(json, "child_weight")
      ? undefined
      : json["child_weight"] == ""
        ? undefined
        : json["child_weight"],
    clinicCounselingId: !exists(json, "clinic_counseling_id") ? undefined : json["clinic_counseling_id"],
    clinicId: !exists(json, "clinic_id") ? undefined : json["clinic_id"],
    correlationId: !exists(json, "correlation_id") ? undefined : json["correlation_id"],
    creditCardId: !exists(json, "credit_card_id") ? undefined : json["credit_card_id"],
    currentSymptoms: !exists(json, "current_symptoms") ? undefined : json["current_symptoms"],
    delivery: !exists(json, "delivery") ? undefined : PharmacyCounselorDeliveryFromJSON(json["delivery"]),
    dispensingType: !exists(json, "dispensing_type") ? undefined : json["dispensing_type"],
    familyAccountId: !exists(json, "family_account_id") ? undefined : json["family_account_id"],
    hasMedicineNotebook: !exists(json, "has_medicine_notebook") ? undefined : json["has_medicine_notebook"],
    insuranceCardType: !exists(json, "insurance_card_type") ? undefined : json["insurance_card_type"],
    isIntegrated: !exists(json, "is_integrated") ? undefined : json["is_integrated"],
    message: !exists(json, "message") ? undefined : json["message"],
    messageToPatient: !exists(json, "message_to_patient") ? undefined : json["message_to_patient"],
    mynaHomeWeb: !exists(json, "myna_home_web")
      ? undefined
      : PharmacyCounselorMynaHomeWebFromJSON(json["myna_home_web"]),
    optionalInformation: !exists(json, "optional_information") ? undefined : json["optional_information"],
    patient: !exists(json, "patient")
      ? undefined
      : PharmacyCounselorPostCounselingRequestPatientFromJSON(json["patient"]),
    personalHealthRecord: !exists(json, "personal_health_record")
      ? undefined
      : PharmacyCounselorPersonalHealthRecordRegistrableFromJSON(json["personal_health_record"]),
    pharmacyId: json["pharmacy_id"],
    preferredTimes: !exists(json, "preferred_times") ? undefined : json["preferred_times"],
    prescription: !exists(json, "prescription")
      ? undefined
      : PharmacyCounselorPrescriptionRegistrableFromJSON(json["prescription"]),
    prescriptions: !exists(json, "prescriptions") ? undefined : json["prescriptions"],
    requestType: !exists(json, "request_type") ? undefined : json["request_type"],
    resumeStatus: !exists(json, "resume_status") ? undefined : json["resume_status"],
    serviceNeeds: !exists(json, "service_needs")
      ? undefined
      : PharmacyCounselorServiceNeedsFromJSON(json["service_needs"]),
    type: json["type"],
    waitingLabel: !exists(json, "waiting_label") ? undefined : json["waiting_label"],
    wantsGeneric: !exists(json, "wants_generic") ? undefined : json["wants_generic"],
  };
}

export function PostCounselingRequestBodyToJSON(object?: PostCounselingRequestBody | null): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    accept_code: value.acceptCode,
    ai_assistant_counseling_id: value.aiAssistantCounselingId,
    ai_assistant_reception_view: value.aiAssistantReceptionView,
    billing: PharmacyCounselorCounselingRequestBillingToJSON(value.billing),
    child_weight: (value.childWeight as unknown as string) == "" ? undefined : value.childWeight,
    clinic_counseling_id: value.clinicCounselingId,
    clinic_id: value.clinicId,
    correlation_id: value.correlationId,
    credit_card_id: value.creditCardId,
    current_symptoms: value.currentSymptoms,
    delivery: PharmacyCounselorDeliveryToJSON(value.delivery),
    dispensing_type: value.dispensingType,
    family_account_id: value.familyAccountId,
    has_medicine_notebook: value.hasMedicineNotebook,
    insurance_card_type: value.insuranceCardType,
    is_integrated: value.isIntegrated,
    message: value.message,
    message_to_patient: value.messageToPatient,
    myna_home_web: PharmacyCounselorMynaHomeWebToJSON(value.mynaHomeWeb),
    optional_information: value.optionalInformation,
    patient: PharmacyCounselorPostCounselingRequestPatientToJSON(value.patient),
    personal_health_record: PharmacyCounselorPersonalHealthRecordRegistrableToJSON(value.personalHealthRecord),
    pharmacy_id: value.pharmacyId,
    preferred_times: value.preferredTimes,
    prescription: PharmacyCounselorPrescriptionRegistrableToJSON(value.prescription),
    prescriptions: value.prescriptions,
    request_type: value.requestType,
    resume_status: value.resumeStatus,
    service_needs: PharmacyCounselorServiceNeedsToJSON(value.serviceNeeds),
    type: value.type,
    waiting_label: value.waitingLabel,
    wants_generic: value.wantsGeneric,
  };
}
